import { cn } from "@devhop/ui";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { format } from "date-fns";
import { dashboardLayout } from "../lib/dashboard-layout";

function greetingForHour(hour: number): string {
  if (hour < 12) return "ສະບາຍດີຕອນເຊົ້າ";
  if (hour < 17) return "ສະບາຍດີຕອນບ່າຍ";
  return "ສະບາຍດີຕອນແລງ";
}

export function DashboardHero() {
  const { user } = useAuthState();
  const now = new Date();
  const displayName = user?.name?.trim() || user?.email || "ຜູ້ໃຊ້";

  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-gradient-to-br from-primary/5 via-card to-card sm:px-5",
        dashboardLayout.cardPad,
      )}
    >
      <p className="text-muted-foreground text-sm">
        {format(now, "EEEE, d MMMM yyyy")}
      </p>
      <h1 className="mt-1 font-bold text-2xl tracking-tight sm:text-3xl">
        {greetingForHour(now.getHours())}, {displayName}
      </h1>
      <p className="mt-2 max-w-2xl text-muted-foreground text-sm">
        ສະຫຼຸບວຽກຄ້າງ, ງານຂອງທ່ານ ແລະ ລິ້ງດ່ວນຕາມສິດການເຂົ້າເຖິງ
      </p>
    </div>
  );
}
